import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22theme.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22./fonts/helvetica-neue-light.woff%22,%22weight%22:%22300%22,%22style%22:%22normal%22},{%22path%22:%22./fonts/helvetica-neue-regular.woff%22,%22weight%22:%22400%22,%22style%22:%22normal%22},{%22path%22:%22./fonts/helvetica-neue-medium.woff%22,%22weight%22:%22500%22,%22style%22:%22normal%22},{%22path%22:%22./fonts/helvetica-neue-bold.woff%22,%22weight%22:%22700%22,%22style%22:%22normal%22}]}],%22variableName%22:%22helvetica%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'helvetica', 'helvetica Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
